'use client'
import {
  PaypalPaymentButton,
  PaypalProvider,
} from '@/core/payment-providers/paypal'
import { useTranslations } from 'next-intl'
import { PaymentStrategy } from './type'

const Fragment: React.FC<{
  children: React.ReactNode
}> = ({ children }) => <>{children}</>

export const usePaypalStrategy: PaymentStrategy = ({
  createdTrip,
  onPaymentSuccess,
  onPaymentFail,
  currency,
}) => {
  useTranslations()

  if (!createdTrip)
    return {
      Button: null,
      Form: null,
      Provider: Fragment,
    }
  return {
    Button: (
      <PaypalPaymentButton
        amount={createdTrip.totalPrice}
        onPaymentSuccess={onPaymentSuccess}
        onPaymentError={onPaymentFail}
        currency={currency}
      />
    ),
    Form: null,
    Provider: PaypalProvider,
  }
}
